export default __webpack_public_path__ + "14992b882e230f22fa1e9f10a2c5f88f.svg";